import React, {useCallback} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Tooltip} from '@optimaxdev/design-system';
import className from 'classnames';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {CART_CTA} from 'constants/analytics/events/cart';
import {PAYPAL_PURCHASE_STORAGE} from 'constants/session';
import paypalCreditRedesign from 'desktop/components/helpers/icons/payInFourRedesign.svg?url';
import paypalCredit from 'desktop/components/helpers/icons/paypalCredit.svg?url';
import {sessionStore} from 'libs/storage/storage';

import {PayPalButtonV3Connected} from '../../paypalButtonV3/paypalButtonV3';

import s from '../paymentsButtons.scss';

export type PropsType = {
    payPalV3: {
        startUrl: string;
        client_id: string;
    } | null;
};

/**
 * Displays paypal payment systems under proceed to checkout button on react cart page
 * @params {PropsType} params
 * @returns {FC} paypal button component
 */
export const PaypalButtonWrapper = ({payPalV3}: PropsType) => {
    const isPaypalV3 = payPalV3 && payPalV3.client_id;
    const shouldShow = Boolean(isPaypalV3);

    const onClick = useCallback(() => {
        sendDesktopAnalyticsEvent(CART_CTA, {
            action: 'Right Section',
            label: 'PayPal Express',
        });
        sessionStore.set(PAYPAL_PURCHASE_STORAGE, 'Cart');
    }, []);

    if (!shouldShow) return null;
    return (
        <div className={s.paypal}>
            <Tooltip
                content={
                    <div className={s.paypalTooltip}>
                        <p>
                            <b>Speed checkout</b> with your PayPal account.
                        </p>
                    </div>
                }
                closeTrigger="hover"
                openTrigger="hover"
                position="left"
                size="small"
            >
                <div className={className(s.button)}>
                    {isPaypalV3 && (
                        <PayPalButtonV3Connected
                            clientId={payPalV3.client_id}
                            name="cartSummaryPaypalButton"
                            onClick={onClick}
                        />
                    )}
                </div>
            </Tooltip>
            <div className={s.creditStyle}>
                <span className={s.availability}>Available with</span>
                <div className={s.paypalCredit}>
                    <CloudinaryImage
                        alt="payPalCredit"
                        height="100%"
                        src={paypalCredit}
                        width="100%"
                    />
                </div>
                <div className={s.payInFour}>
                    <CloudinaryImage
                        alt="payInFour"
                        height="15px"
                        src={paypalCreditRedesign}
                        width="45px"
                    />
                </div>
            </div>
        </div>
    );
};
